export default {

  // 新增车辆管理
  insertPaVehicleInfo: '/ygsjzs/paVehicleInfo/insertPaVehicleInfo',
  // 修改车辆管理
  updatePaVehicleInfo: '/ygsjzs/paVehicleInfo/updatePaVehicleInfo',

  // 删除车辆管理
  deletePaVehicleInfo: '/ygsjzs/paVehicleInfo/deletePaVehicleInfo',
  // 询车辆管理详情
  selectPaVehicleInfoByPlateId: '/ygsjzs/paVehicleInfo/selectPaVehicleInfoByPlateId',
  // 分页查询车辆管理列表
  selectPaVehicleInfoByPage: '/ygsjzs/paVehicleInfo/selectPaVehicleInfoByPage'

}
